import { useQuery, UseQueryOptions } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import { IGetActivitiesParams } from "../../api-client/activities-api"
import moment from "moment-timezone"

interface Params {
  filters: Partial<IGetActivitiesParams['filters']>
  options?: UseQueryOptions<any,any>
}

const DEFAULT_FILTERS = {
  timespan: 'day' as 'day' | 'week' | 'month',
  from: moment().format("YYYY-MM-DD"),
}

export function useActivitiesQuery(params: Params) {
  const {
    filters: paramsFilters,
    options,
  } = params

  const filters = {
    ...DEFAULT_FILTERS,
    ...paramsFilters
  }

  const apiClient = useApiClient()

  const query = useQuery(
    ['activities', filters],
    async () => {
      const response = await apiClient.getActivities({
        filters: filters
      })

      if (response.errors) {
        throw response.errors
      }

      return response
    },
    {
      ...options,
    }
  )

  return query
}